export default {
    labelList:[
        {
            label: '叶天士临床经验挖掘',
            id:'1',
            isShow:true,//当前折叠部分是否打开
            children: [
                {
                    label: '辨病辨证',
                    infoType:'bbbz',
                    id:'1-1',
                    navList:[
                        {
                            value:'中医疾病统计',
                            type:'pie',
                            infoType:'tj'
                        },{
                            value:'临床表现统计',
                            type:'pie',
                            infoType:'lc'
                        },{
                            value:'病位统计',
                            type:'pie',
                            infoType:'bw'
                        },{
                            value:'病性统计',
                            type:'pie',
                            infoType:'bx'
                        },{
                            value:'中医证候统计',
                            type:'pie',
                            infoType:'zh'
                        },{
                            value:'中医疾病-临床表现社团',
                            type:'association',
                            infoType:'zyjb_lc_st'
                        },{
                            value:'中医疾病-中医证候社团',
                            type:'association',
                            infoType:'zyjb_zh_st'
                        },{
                            value:'中医证候-临床表现社团',
                            type:'association',
                            infoType:'zyzh_lc_st'
                        },{
                            value:'中医疾病-中医证候关联',
                            type:'relevance',
                            infoType:'zyjb_zh_gl'
                        },
                    ]
                },
                {
                    label: '治则治法',
                    infoType:'zzzf',
                    id:'1-2',
                    navList:[
                        {
                            value:'治法统计分析',
                            type:'pie',
                            infoType:'zf',
                        },{
                            value:'中医证候-中药关联',
                            type:'relevance',
                            infoType:'zyzh_zygl',
                        },{
                            value:'中药-治法社团分析',
                            type:'association',
                            infoType:'zy_zfst',
                        },{
                            value:'中医疾病-治法社团',
                            type:'association',
                            infoType:'zyjb_zfst',
                        },{
                            value:'中医证候-治法社团',
                            type:'association',
                            infoType:'zyzh_zfst',
                        },{
                            value:'中医证候-中药社团',
                            type:'association',
                            infoType:'zyzh_zyst',
                        },{
                            value:'中医疾病-中药关联',
                            type:'relevance',
                            infoType:'zyjb_zygl',
                        },
                    ]
            },
            {
                    label: '处方用药',
                    id:'1-3', 
                    infoType:'cfyy',
                    navList:[
                        {
                            value:'中药统计',
                            type:'pie',
                            infoType:'tj',
                        },{
                            value:'四气统计',
                            type:'pie',
                            infoType:'sq',
                        },{
                            value:'五味统计',
                            type:'pie',
                            infoType:'ww',
                        },{
                            value:'归经统计',
                            type:'pie',
                            infoType:'gj',
                        },{
                            value:'功效统计',
                            type:'pie',
                            infoType:'gx',
                        },{
                            value:'中药-中药关联',
                            type:'relevance',
                            infoType:'zy_gl',
                        },
                        {
                            value:'中药-中药复杂网络',
                            type:'complex',
                            infoType:'zy_fz',
                        },
                        {
                            value:'中药聚类',
                            type:'cluster',
                            infoType:'jl',
                        },
                    ]
                }, 
            ]
        }, 
    ],
    // 复杂网络-布局
    layoutAll:{
        layoutList:[
            {
                label:'random',
                value:'random',
            },
            {
                label:'mds',
                value:'mds',
            },
            {
                label:'grid',
                value:'grid',
            },
            {
                label:'force',
                value:'force',
            },
            {
                label:'circular',
                value:'circular',
            },
            // {
            //     label:'dagre',
            //     value:'dagre',
            // },
            {
                label:'concentric',
                value:'concentric',
            },
        ],
        // 节点距离
        distanceMarks: {
            1: '1',
            13: '13',
            26: '26',
            38: '38',
            50: '50',
        },
        // 节点大小
        sizeMarks: {
            1: '1',
            25: '25',
            50: '50',
            75:'75',
            100:'100'
        },
        // 字体大小
        fontSizeMarks:{
            1: '1',
            50: '50',
        },
        // 边宽大小
        sideMarks:{
            1: '1',
            3: '3',
            5: '5',
            7:'7',
            10:'10'
        },
        // 节点形状
        shapeList:[
            {
                label:'circle',
            },
            // {
            //     label:'donut',//甜甜圈 
            // },
            {
                label:'ellipse',//椭圆
            },{
                label:'triangle',//三角形
            },{
                label:'rect',//方形
            },{
                label:'diamond',//菱形矩形
            },{
                label:'star',//五角星
            },
        ],
        //边形状
        edgeShapeList:[
            {label:'line'},
            {label:'quadratic'},
            {
                label:'polyline',
            },{
                label:'cubic-vertical',
            },{
                label:'cubic-horizontal',
            },{
                label:'arc',
            },
        ],
        // 边样式
        edgeClassList:[
            {
                label:'solid',
                // path: `G6.Arrow.triangle()`,
            },{
                label:'dashed',
                // path: G6.Arrow.vee(),
            }, {
                label:'dotted',
                // path: G6.Arrow.circle(5, 0),
            }, 
        ]
    }
    
}